import { Button } from "@/components/rac/button";
import { useEffect, useRef, useState } from "react";
interface ResendButtonProps {
  onResend: () => void | Promise<void>;
  isLoading: boolean;
  initialTimer?: number;
  className?: string;
}
export function ResendButton({
  onResend,
  isLoading,
  initialTimer = 0,
  className
}: ResendButtonProps) {
  const [resendTimer, setResendTimer] = useState(initialTimer);
  const [canResend, setCanResend] = useState(initialTimer === 0);
  const [isResending, setIsResending] = useState(false);
  const resendIntervalRef = useRef<NodeJS.Timeout | null>(null);

  // Timer effect for resend functionality
  useEffect(() => {
    if (resendTimer > 0) {
      setCanResend(false);
      resendIntervalRef.current = setInterval(() => {
        setResendTimer(prev => {
          if (prev <= 1) {
            setCanResend(true);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    } else {
      setCanResend(true);
      if (resendIntervalRef.current) {
        clearInterval(resendIntervalRef.current);
        resendIntervalRef.current = null;
      }
    }
    return () => {
      if (resendIntervalRef.current) {
        clearInterval(resendIntervalRef.current);
      }
    };
  }, [resendTimer]);

  // Update timer when initialTimer changes (e.g., when OTP is sent)
  useEffect(() => {
    if (initialTimer > 0) {
      setResendTimer(initialTimer);
      setCanResend(false);
    }
  }, [initialTimer]);
  const handleResend = async () => {
    if (!canResend || isLoading || isResending) return;
    setIsResending(true);
    try {
      const result = onResend();
      // Handle both sync and async functions
      if (result instanceof Promise) {
        await result;
      }
      // Start the timer after successful resend
      setResendTimer(30);
      setCanResend(false);
    } catch (_error) {
      // Error handling is done in the parent component
    } finally {
      setIsResending(false);
    }
  };
  return <Button variant="outline" className={className} onPress={handleResend} isDisabled={isLoading || isResending || !canResend}>
			{resendTimer > 0 ? `Resend in ${resendTimer}s` : "Resend OTP"}
		</Button>;
}